import "./Navbar.scss"

import { FC } from "react"
import { useNavbarStore } from "stores/navbar"

export type NavbarExpandProps = {
    iconImg?: string,
}

const NavbarExpand: FC<React.PropsWithChildren<NavbarExpandProps>> = ({
    iconImg,
}) => {
    const { expandNavbar } = useNavbarStore()

    return (
        <div className="navbar__item navbar__item--expand">
            <div className="navbar__item-body" aria-label="Open Navbar" onClick={() => expandNavbar()}>
                <div className="navbar__item-icon-expand">
                    <img src={iconImg} alt="navbar-expand"/>
                </div>
            </div>
        </div>
    )
};

export default NavbarExpand
